/* Custom JS */
// ReCahrge - Change submit button text
window.addEventListener('load', function() {

  function change_atc() {

    if( document.querySelector('.product-form__submit-preorder') ) {
      document.querySelector('.product-form .product-form__submit span').textContent = 'Pre-order';
      return;
    }

    if( document.getElementById('rc-radio2').checked ){
      document.querySelector('.product-form .product-form__submit span').textContent = 'Subscribe';

      var recharge_widget = document.querySelector('.rc-selling-plans');
      recharge_widget.innerHTML += "<ul class='recharge__features'><li>cancel anytime</li><li>gift and 2x reward points with every order</li><li>free 30-day returns</li><li>free shipping</li></ul>";
      
       // Monitor for change of selling plan
      var selling_plan_dropdown = document.querySelector('[name="rc_selling_plan"]');
      selling_plan_dropdown.addEventListener("change", function() {
        let selling_plan_id = selling_plan_dropdown.value;
        document.querySelector('.product-form-container [name="selling_plan"]').value = selling_plan_id;
      });
      
    } else { 
      document.querySelector('.product-form .product-form__submit span').textContent = 'Add to bag';
    }

  }

  if( document.getElementById('rc-radio2') ) {
    change_atc();
  }

  // Monitor ReCharge radio buttons for change
  var recharge_radios = document.querySelectorAll('.rc-radio__input');  
  recharge_radios.forEach(radio => radio.addEventListener('change', () => change_atc()));

});

// Activate ZenDesk on button click
window.addEventListener('load', function() {

  const live_chat_triggers = document.querySelectorAll('[data-live-chat-trigger]');

  live_chat_triggers.forEach(function(button) {
    button.addEventListener('click', e => {
      e.preventDefault();
      zE('messenger', 'open');
    });
  });

});

// Mobile Filter Trigger
document.addEventListener("DOMContentLoaded", function(event) { 

  if( !document.querySelector("#ProductGridContainer") 
    || !document.querySelector(".filtertrigger__link") ) {
    return;
  }

  document.querySelector(".filtertrigger__link").addEventListener('click', function(e) {      
    // document.querySelector('.mobile-facets__open-wrapper').click();
    // toggle class tw-hidden on element with class .mobile-collection-filter
    document.querySelector('.mobile-collection-filter').classList.toggle('tw-hidden');
  });
});

// Footer Accordion
var show = function (elem) {
  elem.style.display = 'block';
};

var hide = function (elem) {
  elem.style.display = 'none';
};

var toggle = function (elem) {
  // If the element is visible, hide it
  if (window.getComputedStyle(elem).display === 'block') {
    hide(elem);
    return;
  }

  // Otherwise, show it
  show(elem);

};

document.addEventListener("DOMContentLoaded", function(event) { 

  // New Customer - Home Classes
  document.querySelectorAll('.new-customer-landing-child').forEach(function(element) {
    element.parentElement.classList.add('new-customer-landing');
  });

  //Footer Accordion
  if(window.innerWidth <= 750) {
    const accordion_titles = document.querySelectorAll('.footer-block--menu .footer-block__heading');

    accordion_titles.forEach(function(title) {
      title.addEventListener('click', event => {
        var content = title.parentNode.querySelector('.footer-block__details-content');
        toggle(content);
      });
    });
  }

  // Article Product Accordion
  document.querySelectorAll('.article-sidebar-more a').forEach(function(button) {
    button.addEventListener('click', e => {

      e.preventDefault();

      if( button.innerHTML == "Show More" ) {
        button.innerHTML = "Show Less";

        document.querySelectorAll('.cont__box:not(.cont__box-first)').forEach(function(product) {
          product.classList.add('active');
        });

      } else {
        button.innerHTML = "Show More";

        document.querySelectorAll('.cont__box:not(.cont__box-first)').forEach(function(product) {
          product.classList.remove('active');
        });
      }

    });
  });

});

// Hide search icon until Searchanize has loaded
document.addEventListener("DOMContentLoaded", function () {
  let searchElement = document.querySelectorAll('.header__search'), i;
  for (i = 0; i < searchElement.length; ++i) {
    if (!searchElement[i].classList.contains('hidden')) return;
  }

  setTimeout(function(){
    for (i = 0; i < searchElement.length; ++i) {
      searchElement[i].classList.remove('hidden');
    }
  }, 2000);
}); 

// Initiate AOS
AOS.init();

// Globally update TOD for personalisation
document.addEventListener("DOMContentLoaded", function () {

  // var currdate = dayjs().tz("Europe/London").format('HH:mm'),
  //     tod = 'morning';

  // if( String(currdate) <= '12:00' ) {
  //   tod = 'morning';
  // } else if( String(currdate) > '12:00' && String(currdate) < '18:00' ) {
  //   tod = 'afternoon';
  // } else {
  //   tod = 'evening';
  // }

  // document.querySelectorAll('.personalise-tod').forEach(function(el) {
  //   el.innerHTML = tod;
  // });

});

document.addEventListener("DOMContentLoaded", function () {

  // Menu Body Blue
  var body = document.querySelector('#MainContent');

  document.querySelectorAll('.mega-menu').forEach(function(megaMenu) {
    megaMenu.addEventListener('mouseenter', function() {
      body.classList.add('menu_blur');
    });

    megaMenu.addEventListener('mouseleave', function() {
      console.log('leave');
      body.classList.remove('menu_blur');
    });

    // Remove blur when menu item clicked and menu is closing
    var menuItems = document.getElementsByClassName('header__menu-item');
    Array.from(menuItems).forEach(function(menuItem) {
      menuItem.addEventListener('click', function(e) {
        var openDetails = document.querySelector('details[open]') ? true : false;
        if (openDetails) {
          body.classList.remove('menu_blur');
        } 
      });
    });

  });

});
